import { useQuery } from '@tanstack/react-query';
import qs from 'qs';
import { toastr } from 'react-redux-toastr';

import api from 'core/api';

import useAntecipationStore from 'store/Antecipation/state';

const getFeedbackMessage = (status) => {
  useAntecipationStore.getState().setOutdatedPositions(false);
  switch (status) {
    case 200: {
      toastr.success('Sucesso...', 'Posições carregadas!');
      break;
    }
    case 422: {
      // useAntecipationStore().get().setOutdatedPositions(true);
      break;
    }
    default: {
      toastr.error('Ops...', 'Não foi possível carregar as posições!');
      break;
    }
  }
};

async function getAntecipation(Page, filters, OrderBy, operationIds) {
  // const [, page, filters, orderBy, operationIds] = ctx.queryKey;
  const filtersParsed = filters;

  const NEW_FILTERS = filtersParsed ? { ...filtersParsed, ...{ OperationIds: operationIds.operations } } : undefined;

  if (NEW_FILTERS) {
    if (filtersParsed.OperationTimeByMonth.min === 0 && filtersParsed.OperationTimeByMonth.max === 0) delete NEW_FILTERS.OperationTimeByMonth;
    if (filtersParsed.CurrentProfitPercentage.min === 0 && filtersParsed.CurrentProfitPercentage.max === 0) delete NEW_FILTERS.CurrentProfitPercentage;
    if (filtersParsed.CurrentProfitOnMaxContractedPercentage.min === 0 && filtersParsed.CurrentProfitOnMaxContractedPercentage.max === 0) delete NEW_FILTERS.CurrentProfitOnMaxContractedPercentage;
    if (filtersParsed.length === 0) delete NEW_FILTERS.OperationIds;
  }

  const { data, status } = await api.get(`/unwinding/filtered?${qs.stringify({ Page, PageSize: 11, OrderBy, Filters: NEW_FILTERS }, { arrayFormat: 'repeat', allowDots: true })}`);
  getFeedbackMessage(status);

  return { ...data, ...{ statusCode: status } };
}

function useAntecipation(page, filters, orderBy, operationIds) {
  const {
    data,
    isLoading,
    isError,
    isSuccess,
    refetch,
  } = useQuery(
    ['Antecipation', page, filters, orderBy, operationIds],
    async () => getAntecipation(page, filters, orderBy, operationIds),
    {
      retry: (failureCount, error) => console.log('retry', failureCount, error), // Will retry failed requests 10 times before displaying an error
    },
  );

  return {
    filters: data?.filters,
    positions: data?.positions,
    totalPages: data?.totalPages,
    currentPage: data?.currentPage,
    status: data?.statusCode,
    isLoading,
    isError,
    isSuccess,
    refetchAntecipation: refetch,
  };
}

export default useAntecipation;
